// Native Web Component for Review Section
class ReviewSectionNative extends HTMLElement {
  constructor() {
    super();
    this.sectionId = '';
    this.swiper = null;
    this.thumbs = null;
  }

  connectedCallback() {
    this.sectionId = this.getAttribute('data-section-id');
    this.init();
  }

  init() {
    // Add navigation buttons to the DOM
    this.addNavigationButtons();
    // Enable smooth scroll for "Read all" link
    this.enableReadAllScroll();

    // Initialize swiper
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initializeSwiper());
    } else {
      this.initializeSwiper();
    }
  }

  addNavigationButtons() {
    const sectionBlock = document.querySelector(`.section-block-${this.sectionId}`);
    const reviewContainer = document.querySelector(`.review-${this.sectionId}`);
    if (!reviewContainer || !sectionBlock) return;

    // Create navigation buttons
    const prevButton = document.createElement('div');
    prevButton.className = 'review-nav-button review-nav-prev';
    prevButton.setAttribute('data-review-prev', '');
    prevButton.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15,18 9,12 15,6"></polyline>
      </svg>
    `;

    const nextButton = document.createElement('div');
    nextButton.className = 'review-nav-button review-nav-next';
    nextButton.setAttribute('data-review-next', '');
    nextButton.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9,18 15,12 9,6"></polyline>
      </svg>
    `;

    // Add buttons to container
    reviewContainer.style.position = 'relative';
    reviewContainer.appendChild(prevButton);
    reviewContainer.appendChild(nextButton);

    prevButton.addEventListener('click', () => {
      const swiperEle = this.querySelector('swiper-container');
      if (swiperEle) swiperEle.swiper.slidePrev();
    });

    nextButton.addEventListener('click', () => {
      const swiperEle = this.querySelector('swiper-container');
      if (swiperEle) swiperEle.swiper.slideNext();
    });
  }

  initializeSwiper() {
    const container = document.querySelector(`.review-${this.sectionId}`);
    if (!container) return;
    const swiperEl = container.querySelector(`.review-block-frame`);
    if (!swiperEl) return;

    const prevButton = document.querySelector(`[data-review-prev]`);
    const nextButton = document.querySelector(`[data-review-next]`);

    // Wait for swiper elements to be ready
    const initWhenReady = () => {
      // Get main swiper instance
      this.swiper = swiperEl.swiper || null;

      // Add click handlers for navigation buttons
      if (prevButton) {
        prevButton.addEventListener('click', () => {
          if (this.swiper) this.swiper.slidePrev();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          if (this.swiper) this.swiper.slideNext();
        });
      }

      // Configure pagination if swiper exists
      if (this.swiper) {
        // Update pagination styles on slide change
        this.swiper.on('slideChange', () => {
          this.updatePagination();
        });
        
        this.swiper.on('init', () => {
          this.updatePagination();
        });

        // Initial pagination update
        this.updatePagination();
      }
    };

    // Check if swiper is ready, if not wait a bit
    if (swiperEl && swiperEl.swiper) {
      initWhenReady();
    } else {
      // Wait for web components to initialize
      setTimeout(initWhenReady, 100);
    }
  }

  updatePagination() {
    // Pagination is handled automatically by Swiper
    // This method can be used for additional custom pagination styling if needed
    if (this.swiper) {
      const activeIndex = typeof this.swiper.realIndex === 'number' ? this.swiper.realIndex : this.swiper.activeIndex;
      // Custom pagination logic can be added here if needed
      console.log('Active slide:', activeIndex);
    }
  }

  enableReadAllScroll() {
    const container = document.querySelector(`.section-block-${this.sectionId}`);
    if (!container) return;
    const readAllLink = container.querySelector('[data-read-all]');
    if (!readAllLink) return;
    readAllLink.addEventListener('click', (event) => {
      const targetEl = document.querySelector('#review-top') || document.querySelector('#reviews-top');
      if (targetEl) {
        event.preventDefault();
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }
}

// Register the custom element
if (!customElements.get('review-section-native')) {
  customElements.define('review-section-native', ReviewSectionNative);
}